
// import showReservedDateOnCalendar from './get_location_reservations';
let location_id        = '';
let month              = '';
let currentMonth       = new Date().toISOString().slice(0, 7); // Initialize currentMonth
$(document).on('click', '.show_calendar', async function () {

    $('#calendar_wrap').remove()
    $('#create_calendar_wrap').remove()
    $('#edit_calendar_wrap').remove()

    location_id        = $(this).attr('data-location-id');
    location_name      = $(this).attr('data-location');
    password_protected = $(this).attr('data-password-protected');
    console.log("password_protected")
    console.log(password_protected)
    month = new Date().toISOString().slice(0, 7);

    let dates = await getCalendar(location_id, month);

    console.log("dates");
    console.log(dates);
    if (password_protected === 'true' && dates.not_authorised) {
        $('#password-modal').removeClass('hidden');
        $('#submit_password').attr('location-id', location_id);
        return false;
    }

    renderLoadingOverlay();
    showCalendar(dates, location_name, month)

    showReservedDateOnCalendar(location_id)

    // Attach event listeners to buttons
    document.getElementById("prev-month").addEventListener("click", () => navigateMonth(0));
    document.getElementById("next-month").addEventListener("click", () => navigateMonth(2));
})


const getCalendar = async (location_id, month) => {
    try {
        const response = await fetch(`/api/calendar?location_id=${location_id}&month=${month}`, {
            method:  'GET',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content'),
            }
        });
        return await response.json()
    } catch (error) {
        console.log(error)
    }
}
function navigateMonth(offset) {
    const [year, month] = currentMonth.split("-").map(Number);
    const newDate       = new Date(year, month - 1 + offset, 1); // Correctly calculate new month
    currentMonth        = newDate.toISOString().slice(0, 7); // Update currentMonth
    console.log("Navigating to:", currentMonth); // Debug log for navigation
    fetchCalendar(currentMonth); // Fetch and render new month's calendar

}

// Function to fetch and render calendar for a specific month
function fetchCalendar(month) {
    fetch(`/api/calendar?location_id=${location_id}&month=${month}`)
        .then((response) => response.json())
        .then(data => {
            // Multiple statements allowed here
            let new_dates = generateDaysHTML(data, month);
            // console.log(new_dates);
            $('#calendar_dates').html(new_dates);
            $('#calendar_date_display').html(`${moment(month, "YYYY-MM").format("MMMM YYYY")}`);
            // showCalendar(data, location_name, month);
            showReservedDateOnCalendar(location_id);
        })
        .catch((error) => console.error("Error fetching calendar data:", error));

}

function showCalendar(dates, location_name, month) {


    let calendar_wrap = `
    <div id="calendar_wrap" class="fixed !z-40 max-sm:top-1 inset-x-0 inset-y-0 top-0 sm:inset-0 overflow-autox bg-gray-900/80">
        <div id="calendar_scroller" class="flex items-start sm:items-centers pt-8 justify-center h-screen overflow-y-auto close_calendar transition-all duration-300">
            <div class="max-w-3xl mx-auto text-gray-400 w-[400px]">
                <div id="calendar_content" class="" style="display: none;">
                    <div id="calendar" class="flex flex-wrap justify-center gap-4">
                        <div class="modal-content p-2 xs:p-4 pt-4 bg-white dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-lg shadow-lg">
                            <div class="text-2xl font-extrabold text-center dark:text-gray-100 mb-4">${location_name}</div>
                            <div class="w-full flex justify-center items-center mb-4 gap-4">
                                <button id="prev-month" class="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600">
                                    <span class=""><i class="fa fa-chevron-left"></i></span>
                                </button>
                                <h2 id="calendar_date_display" class="text-lg font-semibold w-[140px] text-center dark:text-gray-200">${moment(month, "YYYY-MM").format("MMMM YYYY")}</h2>
                                <button id="next-month" class="bg-blue-500 text-white px-3 py-1 rounded hover:bg-blue-600">
                                    <span class=""><i class="fa fa-chevron-right"></i></span>
                                </button>
                            </div>
                            <div class="grid grid-cols-7 gap-0 xs:gap-2 w-full">
                                            ${[
        `<span class="max-xs:hidden">Mon</span><span class="xs:hidden">M</span>`,
        `<span class="max-xs:hidden">Tue</span><span class="xs:hidden">T</span>`,
        `<span class="max-xs:hidden">Wed</span><span class="xs:hidden">W</span>`,
        `<span class="max-xs:hidden">Thu</span><span class="xs:hidden">T</span>`,
        `<span class="max-xs:hidden">Fri</span><span class="xs:hidden">F</span>`,
        `<span class="max-xs:hidden">Sat</span><span class="xs:hidden">S</span>`,
        `<span class="max-xs:hidden">Sun</span><span class="xs:hidden">S</span>`
    ].map(day => `
                                    <div class="font-medium text-gray-700 dark:text-gray-400 text-center">${day}</div>
                                `).join("")}
                            </div>
                            <div class="grid grid-cols-7 gap-0 xs:gap-2" id="calendar_dates">
                            ${generateDaysHTML(dates, month)}
                            </div>
                        </div>
                    </div>
                    <div id="calendar_controls" class="grid xs:gap-1 sm:gap-2"></div>
                </div>
            </div>
        </div>
    </div>
    `;

    $('body').prepend(calendar_wrap)
    $('#calendar_content').fadeIn(200);

    removeLoadingOverlay();

    $('#slide_in_calendar').click();
}

// Function to generate days HTML
function generateDaysHTML(dates, month) {

    const todays_date = moment().startOf('day'); // Normalize today's date to midnight
    console.log("todays_date")
    console.log(todays_date)

    const firstDayOfMonth = moment(month, "YYYY-MM").startOf("month");
    const lastDayOfMonth  = moment(month, "YYYY-MM").endOf("month");
    const startDay        = firstDayOfMonth.isoWeekday();
    const endDay          = lastDayOfMonth.isoWeekday();

    const daysInPrevMonth = firstDayOfMonth.clone().subtract(1, "month").daysInMonth();
    const prevMonthStart  = daysInPrevMonth - (startDay - 2);

    let html = "";

    // Add previous month's filler days
    for (let i = prevMonthStart; i <= daysInPrevMonth; i++) {
        html += `<div class="text-gray-400 text-center px-2 py-2 xs:py-2 rounded-0 xs:rounded-lg border border-white dark:border-gray-700">${i}</div>`;
    }

    // Add current month's days
    dates.dates.forEach(({date, is_available}) => {

        const dateTimestamp = moment(date).valueOf(); // Convert date to timestamp

        if (dateTimestamp < todays_date) {
            html += `<div class="relative bg-green-100 dark:bg-green-600/40 hover:bg-green-200 dark:hover:bg-green-500/40 text-green-700 dark:text-green-300 cursor-not-allowed text-center px-2 py-2 xs:py-2 rounded-0 xs:rounded-lg border border-white dark:border-gray-700 opacity-40">
                ${moment(date).date()}
            </div>`;
        } else {
            html += `<div class="relative bg-green-100 dark:bg-green-600/40 hover:bg-green-200 dark:hover:bg-green-500/40 text-green-700 dark:text-green-300 cursor-pointer text-center px-2 py-2 xs:py-2 rounded-0 xs:rounded-lg border border-white dark:border-gray-700 show_courts calendar_date"
                data-location-id="${location_id}" data-date="${date}" data-location-name="${location_name}">
                ${moment(date).date()}
            </div>`;
        }

    });

    // Add next month's filler days
    for (let i = 1; i <= (7 - endDay) % 7; i++) {
        html += `<div class="text-gray-400 text-center px-2 py-2 xs:py-2 rounded-0 xs:rounded-lg border border-white dark:border-gray-700">${i}</div>`;
    }

    return html;
}

$(document).on('click', '#close_calendar, .close_calendar', function () {
    month        = new Date().toISOString().slice(0, 7);
    currentMonth = month;
    $('#calendar_wrap').fadeOut(200);
    setTimeout(function () {
        $('#calendar_wrap').remove()
        $(`.trigger-calendar[data-location-id="${location_id}"]`).click();
    }, 200)
})

$(document).on('click', '#calendar_content', function (event) {
    event.stopPropagation();
})

